import { store } from "../redux/store";
import { setDeviceId } from "../redux/device/deviceSlice";

const STORAGE_KEY = "travel_app_device_id";

const readStoredDeviceId = () => {
  try {
    return String(localStorage.getItem(STORAGE_KEY) || "").trim();
  } catch {
    return "";
  }
};

const writeStoredDeviceId = (deviceId) => {
  try {
    localStorage.setItem(STORAGE_KEY, deviceId);
  } catch {
    // ignore quota / private mode
  }
};

/**
 * Stable browser device id for Benzy session scoping.
 * Always send as request header ``X-Device-ID`` (not body DeviceID).
 */
export const getDeviceId = () => {
  let deviceId = String(store.getState()?.device?.deviceId || "").trim();
  if (!deviceId) {
    deviceId = readStoredDeviceId();
  }
  if (!deviceId) {
    const cryptoObj = typeof window !== "undefined" ? window.crypto : undefined;
    deviceId =
      cryptoObj?.randomUUID?.() ||
      `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }
  writeStoredDeviceId(deviceId);
  if (store.getState()?.device?.deviceId !== deviceId) {
    store.dispatch(setDeviceId(deviceId));
  }
  return deviceId;
};

export const getDeviceDetails = () => ({
  name: navigator.userAgent,
  registration_id: "",
  device_id: getDeviceId(),
  type: "web",
});
